import { render, staticRenderFns } from "./EmployeePFGFslips.vue?vue&type=template&id=1b819540"
import script from "./EmployeePFGFslips.vue?vue&type=script&lang=js"
export * from "./EmployeePFGFslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports